// extracted by css-extract-rspack-plugin
export default {"Box":"base-cell-module__Box__qmZzt","editingCell":"base-cell-module__editingCell__JoUWQ","disallowSelection":"base-cell-module__disallowSelection__OjAn9"};